import React from "react";
import Image from "../components/image";
import {connect} from "react-redux";

class PBIDashbordViewFullScreen extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            updatedKey: "k1",
            fullScreenData: {},
            variant: this.props.variant,
            isModelErrFullscreenMode: this.props.isModelErrFullscreenMode,
            prowerbireporturl:this.props.prowerbireporturl,
            powerbititle:this.props.powerbititle


        }
    }

    static getDerivedStateFromProps(props, state) {
        if (props.isModelErrFullscreenMode !== state.isModelErrFullscreenMode) {
            return {
                isModelErrFullscreenMode: props.isModelErrFullscreenMode
            }
        }

        if (props.powerbititle !== state.powerbititle) {
            return {
                powerbititle: props.powerbititle
            }
        }

        if (props.prowerbireporturl !== state.prowerbireporturl) {
            return {
                prowerbireporturl: props.prowerbireporturl
            }
        }
        return null;
    }

   
    

    componentDidMount() {

            var powerbi = window.powerbi;
            var embedConfiguration = {
            type: 'report',
            id:this.props.prowerbireportid,
            embedUrl:this.props.prowerbireporturl,
            accessToken: localStorage.getItem("pb_auth_token"),
            // accessToken:this.props.prowerbireporturl,   
            // id:'dcfa9065-d35a-47ee-9f12-826da976c18c',
            // embedUrl:'https://app.powerbi.com/reportEmbed?reportId=dcfa9065-d35a-47ee-9f12-826da976c18c&groupId=cbbe7bb1-aaac-4a73-ac84-2dc66c236597&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUlORElBLUNFTlRSQUwtQS1QUklNQVJZLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJtb2Rlcm5FbWJlZCI6dHJ1ZSwiYW5ndWxhck9ubHlSZXBvcnRFbWJlZCI6dHJ1ZSwiY2VydGlmaWVkVGVsZW1ldHJ5RW1iZWQiOnRydWUsInVzYWdlTWV0cmljc1ZOZXh0Ijp0cnVlLCJza2lwWm9uZVBhdGNoIjp0cnVlfX0%3d',
            // accessToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6ImpTMVhvMU9XRGpfNTJ2YndHTmd2UU8yVnpNYyIsImtpZCI6ImpTMVhvMU9XRGpfNTJ2YndHTmd2UU8yVnpNYyJ9.eyJhdWQiOiJodHRwczovL2FuYWx5c2lzLndpbmRvd3MubmV0L3Bvd2VyYmkvYXBpIiwiaXNzIjoiaHR0cHM6Ly9zdHMud2luZG93cy5uZXQvMmIxMjdjN2QtMWEwYi00ZTk4LThlOWUtZDMzM2EyYzc4YmE3LyIsImlhdCI6MTY1MzM1ODQzOCwibmJmIjoxNjUzMzU4NDM4LCJleHAiOjE2NTMzNjI2ODAsImFjY3QiOjAsImFjciI6IjEiLCJhaW8iOiJFMlpnWUdBdlAvMm1jdTIwRTl1T3h0V0pwaFMyWFAyVlpLZklYS084UmVGdlNieEJtamtBIiwiYW1yIjpbInB3ZCJdLCJhcHBpZCI6IjNhNTM2MjEwLWU0M2QtNGZlNy04ZTdjLWQ4OGQ2YTg0NzkyNiIsImFwcGlkYWNyIjoiMCIsImlwYWRkciI6IjI3LjUuODkuMTA1IiwibmFtZSI6InByb2R1Y3RfZGV2Iiwib2lkIjoiY2Q1ZTYzZTAtOGE5Ni00OTQ2LThhOTQtZWRmNzdhODI0NzU1IiwicHVpZCI6IjEwMDMyMDAxRUZDMzYwOTgiLCJyaCI6IjAuQVNvQWZYd1NLd3NhbUU2T250TXpvc2VMcHdrQUFBQUFBQUFBd0FBQUFBQUFBQUFxQURrLiIsInNjcCI6IkFwcC5SZWFkLkFsbCBDYXBhY2l0eS5SZWFkLkFsbCBDYXBhY2l0eS5SZWFkV3JpdGUuQWxsIENvbnRlbnQuQ3JlYXRlIERhc2hib2FyZC5SZWFkLkFsbCBEYXNoYm9hcmQuUmVhZFdyaXRlLkFsbCBEYXRhZmxvdy5SZWFkLkFsbCBEYXRhZmxvdy5SZWFkV3JpdGUuQWxsIERhdGFzZXQuUmVhZC5BbGwgRGF0YXNldC5SZWFkV3JpdGUuQWxsIEdhdGV3YXkuUmVhZC5BbGwgR2F0ZXdheS5SZWFkV3JpdGUuQWxsIFJlcG9ydC5SZWFkLkFsbCBSZXBvcnQuUmVhZFdyaXRlLkFsbCBTdG9yYWdlQWNjb3VudC5SZWFkLkFsbCBTdG9yYWdlQWNjb3VudC5SZWFkV3JpdGUuQWxsIFdvcmtzcGFjZS5SZWFkLkFsbCBXb3Jrc3BhY2UuUmVhZFdyaXRlLkFsbCIsInN1YiI6Ims3NkNEcmlPX2hWbHlkM0ZIb1dNdWhnTmRCUTh5ZS1WRHRiYl9ockhJN2siLCJ0aWQiOiIyYjEyN2M3ZC0xYTBiLTRlOTgtOGU5ZS1kMzMzYTJjNzhiYTciLCJ1bmlxdWVfbmFtZSI6InByb2R1Y3RfZGV2QHNhdHVyYW0uY29tIiwidXBuIjoicHJvZHVjdF9kZXZAc2F0dXJhbS5jb20iLCJ1dGkiOiJMeF90VlFNZjZrcXBtblcxOWpzTEFBIiwidmVyIjoiMS4wIiwid2lkcyI6WyJiNzlmYmY0ZC0zZWY5LTQ2ODktODE0My03NmIxOTRlODU1MDkiXX0.ThvIQGdXKHnctqAWwO-atURfUzQtCckuD4TWizfG6qQwkIs2adwesNE_ig4gXPjhLRosO5P9m21bWvp_a6XfF5--kruJzLB39weq4_l6WFGcBYi8mpC8ll8A4ZcakSMAcVw3bCWOA_KTHKVdabhSCHYCVBxjHjCDq7KPMV5WAk_P5TgqVP6J0slI63kad_HA099kjglDpi1Q-G4NqZyHvSIo2jDgMY-WrOFZSHJ1Wbz6G2lFOTU1LN2hNI20tIwx7VjhknCDhPy16PAQGhYg9539_hDcxgj9ylAbt7AkDP28TYV0jYfV4BsvuSkvqdKJ7yI9g6TvsAowTNe3_BSH_w',
            settings: {
            }
            };
            powerbi.embed(document.getElementById("dashboardContainer"), embedConfiguration);
    }

    render() {

        return (
            <div className={"qd-fullscreen fade " + this.props.fullScreenClassVal}>
                <div className="qd-fs_dialog">
                    <div className="qd-fs_content">
                        <div className="qd-fs_header">
                            <div className="header_content">
                                <Image
                                    className="qd-header__brand-logo-default"
                                    src="logo"
                                />
                                <h4 className="header_title">{this.props.powerbititle}</h4>
                            </div>
                            <div className="actions">
                            </div>
                            <button type="button" onClick={this.props.closepireportfullscreen}
                                    className="close" aria-label="Close">
                                <span aria-hidden="true"/>
                                <span className="sr-only">Close</span>
                            </button>
                        </div>
                        <div class="qd-fs_body overflow-auto pt-0">
                        <div id="dashboardContainer" style={{height:"800px"}}></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return state;
}

export default connect(mapStateToProps, null)(PBIDashbordViewFullScreen);